import React from 'react';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import shallowequal from 'shallowequal';
import Icon from '../Icon';
import {Link} from 'react-router';
import svgEdit from '../../svgs/edit.svg';
import filter from "../../filter";
import {executeQuery} from "../../requests/executeQuery";
import {executeBackendQuery} from "../../requests/executeBackendQuery";
import {SELLERS_LIST, SELLERS_LIST_COUNT} from '../../consts/queries';
import LinkComp from "../LinkComp";
import plus from "../../svgs/plus-white.svg";
import FilterButton from '../FilterButton';
import {buildServerQuery, applyClientSort} from "../../sort-utils";


const limit = 50;

export default class SellerList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			items: null,
			totalCount: null,
			error: null,
			isBusy: null,
		};
	}

	componentDidMount() {
		this.fetch(this.props.location.query);
	}

    fetch(q) {
        this.setState({isBusy: true});

        const query = {...q};
        const options = filter(buildServerQuery(query), 'sellers');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

        Promise.all([
            executeBackendQuery({queryName: SELLERS_LIST, options: options}),
            executeBackendQuery({queryName: SELLERS_LIST_COUNT, options: options})
        ]).then(res => {
            this.setState({
                items: applyClientSort(res[0].data, query.order),
                totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
                error: res[0].success ? null : res[0].message,
                isBusy: null,
            });
        });
    }

	componentDidUpdate(prevProps) {
		if (!shallowequal(prevProps.location.query, this.props.location.query)) {
			this.fetch(this.props.location.query);
		}
	}
	render() {
		const query = this.props.location.query;
		const columns = [
			{
				name: 'View',
                columnStyle: {width: 70},
                render: (el)=> (
					<Link to={{pathname: `${arc.path.base}seller/${el.ARCIMEDES_ROW_ID}`}}><Icon svg={svgEdit}/></Link>
				),
			},
			{
				code: 'STATUS',
				name: 'Status',
				render: (el) => el.STATUS,
			},{
				name: 'Seller',
				subColumns: [{
					code: 'FIRST_NAME',
					name: 'First Name',
					render: (el) => el.FIRST_NAME,
				}, {
					code: 'LAST_NAME',
					name: 'Last Name',
					render: (el) => el.LAST_NAME,
				}],
				headerStyle: {
					minWidth: 218,
					justifyContent: 'center'
				},
			}, {
				code: 'EMAIL',
				name: 'Email',
				render: (el) => el.EMAIL ? <a href={`mailto:${el.EMAIL}`}>{el.EMAIL}</a> : null,
			}, {
				code: 'PHONE',
				name: 'Phone',
				columnStyle: {
					minWidth: 132,
				},
				render: (el) => el.PHONE ?
					<a href={`tel:${el.PHONE.replace(' ', '-').replace('(', '').replace(')', '')}`}>{el.PHONE}</a> : null,
			}, {
				code: 'COMPANY_NAME',
				name: 'Company Name',
				render: (el) => el.COMPANY_NAME,
			}
		];
        
		return (
			<div className='SellerList' data-is-busy={this.state.isBusy}>
				<div className='page-rounded-corner-container'>
					<div className='page-header-container list'>
						<div className='page-header list' style={{flexDirection: 'column', alignItems: 'flex-start'}}>
							<div style={{display: 'flex', alignItems: 'center', gap: '10px', width: '100%'}}>
								<div className='page-title'>Sellers</div>
								<LinkComp to={`${arc.path.base}seller`}>
									<div className="button-new plus positive">
										<Icon svg={plus}/>
									</div>
								</LinkComp>
							</div>
							<FilterButton onClick={this.props.openFilter} />
						</div>
						<div className='line'/>
					</div>
				</div>
				<div className='page-body-container'>
					<SortTable columns={columns} items={this.state.items} query={query} hasSubColumns={true} classNameModifier='sellers'/>
					<ListResults query={this.props.location.query} pathname={this.props.location.pathname} error={this.state.error} totalCount={this.state.totalCount} itemCount={this.state.items ? this.state.items.length : false} limit={limit}/>
				</div>
			</div>
		);
	}
}
